import React from 'react';
import { motion } from 'framer-motion';
import { ShieldX, Calculator, HeartPulse, Users } from 'lucide-react';
const values = [{
  icon: ShieldX,
  title: 'No insurance stress',
  description: 'Quality dental care without the insurance hassle, waiting periods, or hidden fees.'
}, {
  icon: Calculator,
  title: 'Predictable costs',
  description: 'Know exactly what you pay each year for your essential preventive care.'
}, {
  icon: HeartPulse,
  title: 'Preventive care included',
  description: '2 cleanings, 2 exams, X-rays, and oral cancer screenings are fully covered.'
}, {
  icon: Users,
  title: 'Family savings',
  description: 'Enjoy a 10% discount on membership fees for additional family members.'
}];
export function ValueProps() {
  return <section className="py-24 lg:py-32 bg-white" data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-191">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-3xl md:text-4xl lg:text-5xl font-light text-brand-dark mb-6 tracking-tight" data-id="element-192">
            A smarter way to stay on top of your dental health
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1,
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-lg text-brand-muted font-light" data-id="element-193">
            The VIP Plan is designed for individuals and families who want
            premium care without the complications of traditional insurance.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-id="element-194">
          {values.map((value, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.8,
          ease: 'easeOut'
        }} className="bg-brand-dark p-8 rounded-3xl" data-id="element-195">
              <div className="w-12 h-12 bg-white/10 rounded-2xl flex items-center justify-center mb-8" data-id="element-196">
                <value.icon className="w-6 h-6 text-white" strokeWidth={1.5} data-id="element-197" />
              </div>
              <h3 className="text-xl font-light text-white mb-4" data-id="element-198">
                {value.title}
              </h3>
              <p className="text-white/60 leading-relaxed font-light" data-id="element-199">
                {value.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}